/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
import IconClose from '@assets/icons/close.svg?react';
import IconPlus from '@assets/icons/plus.svg?react';
import {
 AppBar,
 Box,
 Button,
 CircularProgress,
 Dialog,
 IconButton,
 Menu,
 MenuItem,
 Slide,
 Theme,
 Toolbar,
 Typography,
 useTheme,
} from '@mui/material';
import dayjs from 'dayjs';
import { TransitionProps } from 'notistack';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { useConfirmationDialog } from '../../../contexts/useConfirmationDialog';
import { useAppDispatch } from '../../../redux/hooks';
import {
 getResultPicturesStart,
 ResultPicture,
} from '../../../redux/results/resultsSlice';
import { RootState } from '../../../redux/store';
import {
 deleteWeightingPictureStart,
 uploadWeightingPicturesStart,
} from '../../../redux/weightings/weightingsSlice';
import { createDataUrl } from '../../../utils/base64File';
import { titleStyles } from '../../common/InfoSidebar/infoStyles';
import LazySvg from '../../common/LazySvg';

const Transition = React.forwardRef(
 (
  props: TransitionProps & {
   children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
 ) => <Slide direction="up" ref={ref} {...props} />,
);
Transition.displayName = 'Transition';

const PictureModal = ({
 open,
 handleOpen,
 handleDelete,
 picture,
}: {
 open: boolean;
 handleOpen: (is: boolean) => void;
 handleDelete: () => void;
 picture: ResultPicture;
}) => {
 const th = useTheme();
 return (
  <Dialog
   fullScreen
   open={open}
   onClose={() => handleOpen(false)}
   TransitionComponent={Transition}
  >
   <AppBar
    sx={{
     position: 'relative',
     background: 'white',
     boxShadow: 'none',
    }}
   >
    <Toolbar sx={{ display: 'flex', alignItems: 'center' }}>
     <Box sx={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 18 }}>
      <Typography sx={{ fontSize: 'inherit' }}>
       where to get picture type info?
      </Typography>
      <Box sx={{ display: 'inline-flex', gap: 2 }}>
       <Typography
        sx={{
         fontSize: 'inherit',
         flex: 1,
         color: (theme: Theme) => theme.palette.kemek.gray,
         whiteSpace: 'nowrap',
        }}
       >
        {dayjs(picture?.PicWhen).format('YYYY-MM-DD')}
       </Typography>
       <Typography sx={{ fontSize: 'inherit', whiteSpace: 'nowrap' }}>
        {dayjs(picture?.PicWhen).format('HH:mm:ss')}
       </Typography>
      </Box>
      <Button
       variant="outlined"
       color="error"
       sx={{ height: 40 }}
       endIcon={
        <LazySvg
         name="delete"
         styles={{
          '& path': { stroke: (theme: Theme) => theme.palette.kemek.red },
         }}
        />
       }
       onClick={() => handleDelete()}
      >
       Ištrinti
      </Button>
     </Box>
     <IconButton
      sx={{ ml: 'auto' }}
      edge="start"
      color="inherit"
      onClick={() => {
       handleOpen(false);
      }}
      aria-label="toggle image"
     >
      <IconClose
       style={{
        width: 20,
        height: 20,
        color: th.palette.kemek.darkestGray,
       }}
      />
     </IconButton>
    </Toolbar>
   </AppBar>
   <Box
    sx={{
     display: 'flex',
     justifyContent: 'center',
     alignItems: 'center',
     maxHeight: 'calc(100% - 64px)',
     width: '100%',
     background: th.palette.kemek.gray,
     flex: 1,
    }}
   >
    <Link
     to={createDataUrl(picture?.PicData, picture?.Type)}
     target="_blank"
     style={{
      display: 'block',
      height: '100%',
      maxWidth: '100%',
     }}
     download={`${picture?.Id}.${picture?.Type?.toLowerCase()}`}
    >
     <img
      src={createDataUrl(picture?.PicData, picture?.Type)}
      alt="img"
      style={{ display: 'block', height: '100%' }}
     />
    </Link>
   </Box>
  </Dialog>
 );
};

const PictureBox = ({
 picture,
 small,
}: {
 picture: ResultPicture;
 small?: boolean;
}) => {
 const { t } = useTranslation();
 const dispatch = useAppDispatch();
 const { openDialog: openConfirmationDialog } = useConfirmationDialog();
 const [open, setOpen] = useState(false);

 const handleOpen = (is: boolean) => {
  setOpen(false);
 };

 const handleDelete = () => {
  openConfirmationDialog({
   title: t('global.delete'),
   message: t('global.deleteMessage'),
   onConfirm: () => {
    console.log('onconfirm');
    dispatch(deleteWeightingPictureStart(picture.Id));
   },
  });
 };

 const blobUrl = useCallback(
  () => createDataUrl(picture?.PicData, picture?.Type),
  [picture],
 )();

 return (
  <>
   <Box
    sx={{
     position: 'relative',
     width: '100%',
     height: small ? '54px' : '177px',
     borderRadius: '4px',
     backgroundImage: `url(${blobUrl})`,
     backgroundSize: 'cover',
     backgroundPosition: 'center',
     backgroundRepeat: 'no-repeat',
     cursor: 'pointer',
    }}
    // onMouseEnter={() => setHovered(true)}
    // onMouseLeave={() => setHovered(false)}
    onClick={() => setOpen(true)}
   />
   {useMemo(
    () => (
     <PictureModal
      open={open}
      handleOpen={() => handleOpen(!open)}
      handleDelete={handleDelete}
      picture={picture}
     />
    ),
    [open],
   )}
  </>
 );
};

const InfoImages = ({ data }: { data: any }) => {
 //  console.log('InfoImages');
 const { t } = useTranslation();
 const dispatch = useAppDispatch();
 const { loading, success, pictures } = useSelector(
  (state: RootState) => state.results,
 );
 const {
  loading: weightingLoading,
  success: weightingSuccess,
  weightingPictures,
 } = useSelector((state: RootState) => state.weightings);
 const th = useTheme();
 //  const loading = useSelector((state: RootState) => state.weightings.loading);
 //  const success = useSelector((state: RootState) => state.weightings.success);

 //  const pictures = useSelector(
 //   (state: RootState) => state.weightings.weightingPictures,
 //  );

 //  console.log(pictures);

 const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

 const handlePicturesUpload = async (weightingId: number) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.multiple = true;
  input.accept = 'image/*';
  input.onchange = (event) => {
   const { files } = event.target as HTMLInputElement;

   if (files) {
    dispatch(
     uploadWeightingPicturesStart({
      weighingId: weightingId,
      files,
     }),
    );
   }
  };
  input.click();
 };

 useEffect(() => {
  // console.log('data?.Id', data?.Id);
  if (data?.Id) {
   dispatch(getResultPicturesStart(data?.Id));
  }
 }, [data?.Id]);

 useEffect(() => {
  if (weightingSuccess?.uploadWeightingPictures) {
   dispatch(getResultPicturesStart(data?.Id));
  }
 }, [weightingSuccess]);

 return (
  <Box sx={{ mb: 3 }}>
   <Typography sx={{ ...titleStyles }}>
    Nuotraukos{' '}
    <IconButton
     id="result-sidebar-image-menu-button"
     aria-controls={anchorEl ? 'result-sidebar-image-menu' : undefined}
     aria-haspopup="true"
     aria-expanded={anchorEl ? 'true' : undefined}
     onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
      setAnchorEl(e.currentTarget)
     }
     //  onClick={() => {
     //   handlePicturesUpload();
     //  }}
    >
     <IconPlus style={{ color: th.palette.kemek.darkestGray }} />
    </IconButton>
    <Menu
     id="result-sidebar-image-menu"
     MenuListProps={{
      'aria-labelledby': 'result-sidebar-image-menu-button',
      disablePadding: true,
     }}
     anchorEl={anchorEl}
     open={!!anchorEl}
     onClose={() => setAnchorEl(null)}
     //  anchorOrigin={{
     //   vertical: 'bottom',
     //   horizontal: 'right',
     //  }}
     //  transformOrigin={{
     //   vertical: 'top',
     //   horizontal: 'right',
     //  }}
    >
     <MenuItem onClick={() => handlePicturesUpload(data?.Bruto?.Id)}>
      <Typography variant="inherit">
       {t('results.upload')} {t('results.bruto')}
      </Typography>
     </MenuItem>
     <MenuItem onClick={() => handlePicturesUpload(data?.Tare?.Id)}>
      <Typography variant="inherit">
       {t('results.upload')} {t('results.tare')}
      </Typography>
     </MenuItem>
    </Menu>
   </Typography>
   {loading?.getResultPictures ? (
    <CircularProgress />
   ) : pictures?.length ? (
    <Box
     sx={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1,
     }}
    >
     <Box sx={{ width: '64%' }}>
      <PictureBox key={pictures[0]?.Id} picture={pictures[0]} />
     </Box>
     <Box
      sx={{
       flex: 1,
       display: 'flex',
       flexDirection: 'column',
       gap: 1,
       alignItems: 'flex-start',
      }}
     >
      {pictures
       ?.slice(1)
       .map((picture: ResultPicture) => (
        <PictureBox key={picture.Id} picture={picture} small />
       ))}
     </Box>
    </Box>
   ) : (
    <Typography variant="inherit">{t('global.noPictures')}</Typography>
   )}
  </Box>
 );
};
export default InfoImages;
